/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/photo_medium'
export default icon
